import { supabase } from '../lib/supabase'
import { SchemaImpianto, type DatiImpianto } from './impianto.schema'
import type { TipologiaImpianto, TipologiaDichiarante } from '@praticheenergia/domain'

export { SchemaImpianto }
export type { DatiImpianto }

export interface DettaglioImpianto {
  readonly id: number
  readonly codiceImpianto: string | null
  readonly codiceDitta: string
  readonly tipologia: TipologiaImpianto
  readonly tipologiaDichiarante: TipologiaDichiarante
  readonly potenzaNominale: number | null
  readonly codiceDestinatarioOfficina: string | null
  readonly ragioneSociale: string
}

export async function caricaImpianto(id: number): Promise<DettaglioImpianto> {
  const { data, error } = await supabase
    .from('impianto')
    .select('id, codice_impianto, codice_ditta, tipologia, tipologia_dichiarante, potenza_nominale, codice_destinatario_officina, azienda(ragione_sociale)')
    .eq('id', id)
    .single()
  if (error) throw new Error(error.message)
  const r = data as Record<string, unknown>
  const azienda = r.azienda as Record<string, unknown> | null
  return {
    id: r.id,
    codiceImpianto: r.codice_impianto,
    codiceDitta: r.codice_ditta,
    tipologia: r.tipologia,
    tipologiaDichiarante: r.tipologia_dichiarante,
    potenzaNominale: r.potenza_nominale,
    codiceDestinatarioOfficina: r.codice_destinatario_officina,
    ragioneSociale: azienda?.ragione_sociale,
  } as DettaglioImpianto
}

/** Azienda e impianto nascono insieme: una sola transazione, lato server. */
export async function creaImpiantoConAzienda(dati: DatiImpianto) {
  const v = SchemaImpianto.safeParse(dati)
  if (!v.success) throw new Error(v.error.issues[0]!.message)
  const { data, error } = await supabase.functions.invoke('crea-impianto', { body: v.data })
  if (error) throw new Error(error.message)
  return data as { impiantoId: number; aziendaId: number }
}
